import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import type { Action, ThunkAction } from '@reduxjs/toolkit'

import ToastReducer from './Toast/toastSlice'
import userReducer from './UserInfo/UserInfoSlice'
import tenantReducer from './Tenant/TenantSlice'
import loadingReducer from './Loading/loadingSlice'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'tenant', // Persist tenant information
  ],
}

const rootReducer = combineReducers({
  toast: ToastReducer,
  userInfo: userReducer,
  tenant: tenantReducer,
  loading: loadingReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

// persistStore setting
export const persistor = persistStore(store)

// Expose store to window for debugging (development only)
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  ;(window as any).store = store
}

// define types
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store
